<span class="app-bar-title-content" fxHide.xs ngClass.lt-lg="layout padding-left-xs">
  {{title}}
</span>
<span class="app-bar-title-content layout padding-left-xs" fxHide.gt-xs>
  {{title | truncate : 16}}
</span>
